<template>
    <div class="plugin-item">
        <CompassIcon :icon="plugin.icon" />
        <div>
            <p>
                <span class="typographies-paragraph-medium-bold">{{ plugin.title }} </span>
                <span v-if="plugin.plan" class="typographies-paragraph-small-semibold"
                    >— {{ plugin.subtitle[plugin.plan] }}</span
                >
            </p>
            <p class="description typographies-paragraph-small-regular">
                {{ plugin.description }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        plugin: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
p {
    margin: 0;
}

.plugin-item {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-1);
}

.description {
    color: var(--colors-common-text-standard-placeholder);
    width: 275px;
}
</style>
